import * as Sentry from '@sentry/react';
import React from 'react';
import Features from './components/Features';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import HowItWorks from './components/HowItWorks';
import Model from './components/Model';
import Navbar from './components/Navbar';

const App = () => {
    return (
        <main className='bg-black overflow-y-auto overflow-x-hidden'>
            <Navbar />
            <Hero />
            <Highlights />
            <Model />
            <Features />
            <HowItWorks />
            <Footer />
        </main>
    );
};

export default Sentry.withProfiler(App);
